const propsData = [
  {
    id: 1,
    name: "Google",
    url: "https://www.google.com/",
    buttonStyle: "btn--google",
    type: "button"
  },
  {
    id: 2,
    name: "tesla",
    url: "https://tesla.com",
    buttonStyle: "btn--tesla",
    type: "button"
  },
  {
    id: 3,
    name: "Uber",
    url: "https://www.uber.com/",
    buttonStyle: "btn--uber",
    type: "button"
  },
  {
    id: 4,
    name: "Windows",
    url: "",
    buttonStyle: "btn--windows",
    type: "button"
  },
  {
    id: 5,
    name: "twitter",
    url: "https://www.twitter.com/",
    buttonStyle: "btn--twitter",
    type: "button"
  },
  {
    id: 6,
    name: "Linkedin",
    url: "https://www.linkedin.com/",
    buttonStyle: "btn--linkedin",
    type: "button"
  },
  {
    id: 7,
    name: "netflix",
    url: "https://www.netflix.com/",
    buttonStyle: "btn--netflix",
    type: "button"
  },
  {
    id: 8,
    name: "Amazon",
    url: "",
    buttonStyle: "btn--amazon",
    type: "button"
  },
  {
    id: 9,
    name: "McDonalds",
    url: "https://www.mcdonalds.com/",
    buttonStyle: "btn--mcdonalds",
    type: "button"
  },
  {
    id: 10,
    name: "Nvidia",
    url: "https://www.nvidia.com/",
    buttonStyle: "btn--nvidia",
    type: "button"
  },
  {
    id: 11,
    name: "Nike",
    url: "https://www.nike.com/",
    buttonStyle: "btn--nike",
    type: "button"
  },
  {
    id: 12,
    name: "Facebook",
    url: "https://www.facebook.com/",
    buttonStyle: "btn--facebook",
    type: "button"
  },
  {
    id: 13,
    name: "Spotify",
    url: "https://spotify.com/",
    buttonStyle: "btn-spotify",
    type: "button"
  },
  {
    id: 14,
    name: "Slack",
    url: "https://slack.com/",
    buttonStyle: "btn--slack",
    type: "button"
  },
  {
    id: 15,
    name: "Le wagon",
    url: "https://www.lewagon.com/",
    buttonStyle: "btn--lewagon",
    type: "button"
  },
  {
    id: 16,
    name: "PIER.",
    url: "https://www.pier.digital/",
    buttonStyle: "btn--pier",
    type: "button"
  },
  {
    id: 17,
    name: "SAMSUNG",
    url: "https://www.samsung.com/",
    buttonStyle: "btn--samsung",
    type: "button"
  },
  {
    id: 18,
    name: "Burguer King",
    url: "https://www.bk.com/",
    buttonStyle: "btn--burguer-king",
    type: "button"
  },
  {
    id: 19,
    name: "Sotheby's",
    url: "https://www.sothebys.com/",
    buttonStyle: "btn--sothebys",
    type: "button"
  },
  {
    id: 20,
    name: "Discord",
    url: "https://discord.com/",
    buttonStyle: "btn--discord",
    type: "button"
  },
  {
    id: 21,
    name: "Notion",
    url: "https://www.notion.so/",
    buttonStyle: "btn--notion",
    type: "button"
  },
  {
    id: 22,
    name: "Stack Overflow",
    url: "https://stackoverflow.com/",
    buttonStyle: "btn--stack-overflow",
    type: "button"
  },
  {
    id: 23,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 24,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 25,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 26,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 27,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 28,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 29,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 30,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 31,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 32,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 33,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 34,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 35,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 36,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 37,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 38,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 39,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 40,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 41,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 42,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 43,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 44,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 45,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 46,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 47,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 48,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 49,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 50,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 51,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 52,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 53,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 54,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 55,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 56,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 57,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 58,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 59,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 60,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 61,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 62,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 63,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 64,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 65,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 66,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 67,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 68,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 69,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 70,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 71,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 72,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 73,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 74,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 75,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 76,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 77,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 78,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 79,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 80,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 81,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 82,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 83,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 84,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 85,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 86,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 87,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 88,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 89,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 90,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 91,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 92,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 93,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 94,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 95,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 96,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 97,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 98,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 99,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  },
  {
    id: 100,
    name: "Button",
    url: "",
    buttonStyle: "",
    type: "button"
  }
];

export default propsData;
